module.exports = "<div class=\"main-app\">\n  <router-outlet name=\"main\"></router-outlet>\n</div>\n"